// Define allowed roles
const ALLOWED_ROLES = [
  'editor-in-chief',
  'editor_in_chief',
  'editorial_assistant',
  'editorial-assistant',
  'associate_editor',
  'associate-editor',
  'admin'
];

// Roles restricted to top editorial management (Editors-in-Chief and Admins only)
const EIC_ADMIN_ROLES = [
  'editor-in-chief',
  'editor_in_chief',
  'admin'
];

export default ALLOWED_ROLES;
export { EIC_ADMIN_ROLES, ALLOWED_ROLES };